const MENU_AVAILABILITY_FILTER = {
  AVAILABLE_FOR_TIER_ONE: {
    label: 'Available For Tier One',
    value: 'AVAILABLE_FOR_TIER_ONE',
  },
  AVAILABLE_FOR_UNKNOWN_WORDS_CURATION: {
    label: 'Available For Unknown Words Curation',
    value: 'AVAILABLE_FOR_UNKNOWN_WORDS_CURATION',
  },
  AVAILABLE_FOR_UNKNOWN_WORDS_QA: {
    label: 'Available For Unknown Words Qa',
    value: 'AVAILABLE_FOR_UNKNOWN_WORDS_QA',
  },
  AVAILABLE_FOR_CURATION: {
    label: 'Available For Curation',
    value: 'AVAILABLE_FOR_CURATION',
  },
  AVAILABLE_FOR_QA: {
    label: 'Available For Qa',
    value: 'AVAILABLE_FOR_QA',
  },
  AVAILABLE_FOR_QC: {
    label: 'Available For Qc',
    value: 'AVAILABLE_FOR_QC',
  },
}

export default MENU_AVAILABILITY_FILTER
